<template>
    <select v-model="selected">
        <option value="">Gerente</option>
        <option :value="gerente.id" v-for="gerente in gerentes" :key="gerente.id">{{ gerente.name }}</option>
    </select>
</template>
<script>

import LoadAllQuery from '../../graphql/user/load-all.gql';

export default {
    props: ['value', 'realEstateId'],
    data() {
        return {
            proxy: this.value,
            gerentes: []
        };
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.proxy = value;
                this.$emit('input', value);
            }
        }
    },
    methods: {
        fetchData() {
            this.gerentes = [];
            if (!this.realEstateId) {
                return;
            }
            const query = LoadAllQuery;
            const variables = {
                filter: {
                    type: 'GERENTE',
                    realEstate: {
                        id: this.realEstateId
                    }
                }
            };
            this.$apollo.query({
                query,
                variables
            }).then(({ data, errors}) => {
                if (errors) {
                    let [error] = errors;
                    throw error;
                }
                let { users } = data;
                this.gerentes = [...users];
            }).catch(err => {
                console.error(err);
            });
        }
    },
    created() {
        this.fetchData();
    }
}
</script>